import styles from './TrendsWidget.module.css';
import Image from "next/image";
import { useGlobalContext } from "../../../../lib/context";
import { cmsLoader, staticLoader } from "../../../../lib/helpers/imageLoader"
import { IBlogPost, IRelatedCat } from '@/interfaces';
import { NavLink } from '@/components/ui';
import React, { useState } from 'react';
import { pushRoute } from '@/lib/helpers/common';
import { useRouter } from 'next/router';

type props = {
    data?: IBlogPost[],
    relatedCat?: IRelatedCat[]
}
export function TrendsWidget({ data, relatedCat }: props) {
    const { props: { isMobileView, countryCode, pageURL } } = useGlobalContext();
    const router = useRouter();
    const catSlug = router.query.category;
    const baseUrl = `${process.env.SITE_URL}/${countryCode}`;
    const [active, setActive] = useState(relatedCat && relatedCat.length > 0 && relatedCat[0].cat_slug);

    if (pageURL.includes('trends') && relatedCat && relatedCat?.length > 0) {
        return <div className={`${styles.trendsWidgetSec} ${styles.detail}`}>
            <h2 className={`${styles.widgitHeading} text222 f600 font26`}>Related Category</h2>
            <ul className={styles.typeOfTrends}>
                {relatedCat.map((f, idx) => <li className={active === f.cat_slug ? styles.active : ''} key={idx} onClick={() => setActive(f.cat_slug)}>{f.cat_name}</li>)}
            </ul>
            <div className={styles.trendsMainBox}>
                <div className={styles.widgetSet}>
                    <Image
                        className="img-responsive"
                        src="/assets/images/trendsBannerWidget.svg"
                        alt="TrendsBannerWidget"
                        width={250}
                        height={isMobileView ? 204 : 172}
                        loader={staticLoader}
                    />
                </div>
                {relatedCat && relatedCat.length > 0 && relatedCat.map((f, idx) =>
                    <div className={active === f.cat_slug ? styles.widgetDetailBox : 'displayNone'} key={idx}>
                        {f && f.posts && f.posts.length > 0 && f.posts.map((m, idx) =>
                            <div key={idx} className={styles.detailTile}>
                                <div className={styles.tileImg} onClick={() => pushRoute(`${baseUrl}/trends/${m.post_slug}`)}>
                                    <Image
                                        className="img-responsive"
                                        src={m.post_relative || 'wp-content/uploads/2022/01/Introduction-to-Some-Amazing-DIY-and-Handmade-Craft-Ideas-for-Home-Decor-1.png'}
                                        alt={m.post_title}
                                        width={84}
                                        height={54}
                                        loader={cmsLoader}
                                    />
                                </div>
                                <NavLink href={`${baseUrl}/trends/${m.post_slug}`} >
                                    <div className={styles.tileContent}>
                                        <p className="lineHeight16 text222 font12">{m.post_title}</p>
                                    </div>
                                </NavLink>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    }
    else if (data && data?.length > 0) return (
        <div className={styles.trendsWidgetSec}>
            <h2 className={`${styles.widgitHeading} text222 f600 font26`}>{(catSlug === "modular-kitchen" ? "kitchen" : catSlug)?.toString().slugToText()} Design Related Blogs</h2>
            <div className={styles.trendsMainBox}>
                <div className={styles.widgetSet}>
                    <Image
                        className="img-responsive"
                        src="/assets/images/trendsBannerWidget.svg"
                        alt="TrendsBannerWidget"
                        width={250}
                        height={isMobileView ? 204 : 172}
                        loader={staticLoader}
                    />
                </div>
                <div className={styles.widgetDetailBox}>
                    {data && data.length > 0 && data.map((f, idx) =>
                        <div className={styles.detailTile} key={idx}>
                            <div className={styles.tileImg} onClick={() => pushRoute(`${baseUrl}/trends/${f.parmalink}`)}>
                                <Image
                                    className="img-responsive"
                                    src={f.post_relative}
                                    alt={f.post_title}
                                    width={84}
                                    height={54}
                                    loader={cmsLoader}
                                />
                            </div>
                            <NavLink href={`${baseUrl}/trends/${f.parmalink}`} >
                                <div className={styles.tileContent}>
                                    <p className="lineHeight16 text222 font12">{f.post_title}</p>
                                </div>
                            </NavLink>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
    else return <></>;
}